import { computed } from '@vue/composition-api';
import store from '@/store/index';

/**
 * @description 获取用户信息
 * @returns {*} {id, nickname, portrait}
 */
export default function useGetUserInfo() {
  if (!store.state.user) {
    store.dispatch('getUserData');
  }

  const user = computed(() => store.state.user);

  return {
    user
  };
}
